import updateAverage from "./update_average";

import {LlmRunScore, SingleTestResult} from "common/flowmaster/types/llm_run";
import {ScoreAnalysis} from "../types";

export default function updateScore(
  scoreAnalysis: ScoreAnalysis,
  llmRunScore: LlmRunScore,
  runResults: SingleTestResult[],
): ScoreAnalysis {
  const {runs} = scoreAnalysis;
  const runCount = runs.length;
  const allPass = runResults
    ? Object.values(runResults).every(item => item.state !== "fail")
    : false;
  const updatedScoreAnalysis = {
    score: updateAverage(scoreAnalysis.score, runCount, allPass ? 1 : 0),
    runs: [...runs, {...llmRunScore, pass: allPass, tests: runResults}],
  };

  return updatedScoreAnalysis;
}
